import styled from "styled-components";

export const Wrap = styled.div`
  background-color: #0C1A53;
`;

export const SearchWrap = styled.div`
  width: 83.52%;
  margin: 0 auto;
  padding-top: 40px;
`;

export const TextImg = styled.div`
  margin: 0 auto;
  width: 100%; 
  padding-top: 20.23%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
`;

export const SearchArea = styled.button`
  display: flex;
  align-items: center;
  margin: 16px auto 0;
  color: ${({ value }) => value ? '#222222' : '#979797'};
  width: 74.64%;
  height: 74px;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 22px;
  line-height: 38px;
  outline: none;
  border: none;
  text-align: left;
  border-radius: 2px;
  overflow: hidden;
  white-space: nowrap;
  
  > svg {
    margin: 16px;
  }

  @media only screen and (max-width: 640px) {
    height: 44px;
    font-size: 14px;
    line-height: 24px
  }    
`;
